import { addVariants } from '@agilemd/ui-utils';

import styles from './styles.module.scss';

export const VARIANTS = ['default', 'thick', 'with-track'];
const STATES = {
  IN_PROGRESS: 'in-progress',
  INDETERMINATE: 'indeterminate'
};

export interface ProgressIndicatorProps {
  /**
   * Decides the variant of the button
   */
  variant?:
    | 'default'
    | 'thick'
    | 'with-track'
    | boolean
    | ('default' | 'thick' | 'with-track' | boolean)[];
  progress?: boolean | number;
  steps?: number;
}

const DEFAULT_INLINE_STYLES = {};

/**
 * A ProgressIndicator is useful as something to show the user while a large section or page is loading data it needs to render
 */
const ProgressIndicator = ({
  progress = false,
  steps = 100,
  variant = 'default'
}: ProgressIndicatorProps): React.JSX.Element => {
  let state = STATES.IN_PROGRESS;
  let inlineStyles = DEFAULT_INLINE_STYLES;

  if (progress !== Number(progress)) {
    state = STATES.INDETERMINATE;
  } else {
    inlineStyles = {
      right: `${100 - (progress / (steps || 100)) * 100}%`
    };
  }

  return (
    <div className={addVariants('aglmd-progress-indicator__track', styles, variant)}>
      <div
        className={addVariants('aglmd-progress-indicator', styles, state, variant)}
        style={inlineStyles}
      />
    </div>
  );
};

export default ProgressIndicator;
